import { Tables } from "@/gen/tableNames/tables";
import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { createEnum } from "@/lib/utils/createEnum";

export type C5PdfPageSelection = {
  id: number;
  client: string | null;
  page_name: string | null;
  tableau_view: string | null;
  tableau_workbook_id: string | null;
  pdf_report_display: boolean | null;
  created_at: string;
};
export const c5PdfPageSelectionFields = createEnum<C5PdfPageSelection>();

export const columns: ColumnDef<C5PdfPageSelection>[] = [
  {
    accessorKey: c5PdfPageSelectionFields.id,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.id`, {
        ns: "tables",
        defaultValue: "ID",
      }),
  },
  {
    accessorKey: c5PdfPageSelectionFields.client,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.client`, {
        ns: "tables",
        defaultValue: "Client",
      }),
  },
  {
    accessorKey: c5PdfPageSelectionFields.page_name,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.page_name`, {
        ns: "tables",
        defaultValue: "Page name",
      }),
  },
  {
    accessorKey: c5PdfPageSelectionFields.tableau_view,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.tableau_view`, {
        ns: "tables",
        defaultValue: "Tableau view",
      }),
  },
  {
    accessorKey: c5PdfPageSelectionFields.tableau_workbook_id,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.tableau_workbook_id`, {
        ns: "tables",
        defaultValue: "Tableau workbook ID",
      }),
  },
  {
    accessorKey: c5PdfPageSelectionFields.pdf_report_display,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.pdf_report_display`, {
        ns: "tables",
        defaultValue: "PDF report display",
      }),
    cell: ({ getValue }) =>
      getValue() && (
        <div className="flex justify-center pr-12">
          <CheckIcon />
        </div>
      ),
  },
  {
    accessorKey: c5PdfPageSelectionFields.created_at,
    header: () =>
      i18n.t(`${Tables.C5_PDF_PAGE_SELECTION}.columns.created_at`, {
        ns: "tables",
        defaultValue: "Created at",
      }),
    cell: ({ row }) => {
      return parseDate(row.getValue(c5PdfPageSelectionFields.created_at));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue(c5PdfPageSelectionFields.id)}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
